<template>
  <div id="empty-state">
    <div class="tw-flex tw-flex-col tw-items-center">
      <img class="" :src="imageUrl" alt="empty file" loading="lazy" />
      <slot name="message">Nothing to show</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    //for when we have different types of empty state images, using a name can help select empty state image as opposed to creating different types of empty state
    name: {
      // add values here ['transactions', 'credit-provider']
      type: String,
      required: false,
    },
  },
  computed: {
    imageUrl() {
      const name = this.name;
      let url = null;
      switch (name) {
        case "transaction":
          url =
            "https://res.cloudinary.com/djalafcj9/image/upload/v1654603955/getequityV2/empty-drawer-svgrepo-com_1_sulhvm.png";
          break;
        case "employeeBenefits":
          url =
            "https://res.cloudinary.com/djalafcj9/image/upload/v1654678331/getequityV2/Handshake_Two_Color_1_ffwgnq.svg";
          break;
        case "publicRaise":
          url =
            "https://res.cloudinary.com/djalafcj9/image/upload/v1655260551/getequityV2/Company-dealroom/empty-state_l18mx9.svg";
          break;
        // if not set, use default
        default:
          url =
            "https://res.cloudinary.com/djalafcj9/image/upload/v1634648059/getequityV2/empty-state_g5ktb2.png";
          break;
      }
      return url;
    },
  },
};
</script>

<style lang="scss" scoped></style>
